import React from 'react';
import { X } from 'lucide-react';

export default function CustomerFilters({ filters, setFilters, onClose }) {
  const handleReset = () => {
    setFilters({
      industry: '',
      subscriptionStatus: '',
      minRevenue: '',
      maxRevenue: ''
    });
  };

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Filters</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Industry Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Industry
          </label>
          <select
            value={filters?.industry}
            onChange={(e) => setFilters({ ...filters, industry: e?.target?.value })}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">All Industries</option>
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
            <option value="industrial">Industrial</option>
            <option value="government">Government</option>
            <option value="other">Other</option>
          </select>
        </div>

        {/* Subscription Status Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Subscription Status
          </label>
          <select
            value={filters?.subscriptionStatus}
            onChange={(e) => setFilters({ ...filters, subscriptionStatus: e?.target?.value })}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">All Statuses</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="trial">Trial</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        {/* Min Revenue Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Min Revenue
          </label>
          <input
            type="number"
            value={filters?.minRevenue}
            onChange={(e) => setFilters({ ...filters, minRevenue: e?.target?.value })}
            placeholder="0"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            min="0"
          />
        </div>

        {/* Max Revenue Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Max Revenue
          </label>
          <input
            type="number"
            value={filters?.maxRevenue}
            onChange={(e) => setFilters({ ...filters, maxRevenue: e?.target?.value })}
            placeholder="1000000"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            min="0"
          />
        </div>
      </div>
      {/* Reset Button */}
      <div className="mt-4 flex justify-end">
        <button
          onClick={handleReset}
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
}